/* eslint-disable no-restricted-imports */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { Close, Description } from '@material-ui/icons';

import XLSX from 'xlsx';

export function ComponentsNotFoundDialog({ isOpen, handleClose, notFoundComponents }) {
  if (!isOpen) return null;

  const handleDownload = async () => {
    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.json_to_sheet([...notFoundComponents.map((item) => ({ a: item }))], {
      skipHeader: 1,
    });

    XLSX.utils.book_append_sheet(wb, ws, 'No Header');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'NotFoundComponents.xlsx');
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth='md'
      PaperProps={{
        style: {
          borderRadius: 12,
        },
      }}
    >
      <DialogTitle>
        <Typography variant='h6' style={{ fontWeight: 600 }}>
          Componentes Não Encontrados
        </Typography>
        <Typography variant='body2' color='textSecondary'>
          {notFoundComponents.length} componentes não foram encontrados no sistema
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant='body1'>
            Os seguintes números de peça não existem no banco de dados:
          </Typography>

          <Box display='flex' justifyContent='flex-end' mb={2}>
            <Link
              component='button'
              variant='body2'
              onClick={handleDownload}
              color='primary'
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Description fontSize='small' style={{ marginRight: 4 }} />
              Baixar planilha
            </Link>
          </Box>
        </Box>

        <Paper variant='outlined' style={{ maxHeight: 400, overflow: 'auto', borderRadius: 8 }}>
          <TableContainer>
            <Table stickyHeader size='small'>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>
                    Part Number
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {notFoundComponents.map((partNumber, index) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <Box display='flex' alignItems='center'>
                        <Close style={{ color: 'red', marginRight: 8, fontSize: 16 }} />
                        {partNumber}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Box mt={3} display='flex' justifyContent='flex-end'>
          <Button
            variant='contained'
            color='primary'
            onClick={handleClose}
            style={{ borderRadius: 8 }}
          >
            Fechar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
